import React from 'react';
import { Heart } from 'react-feather';
import './SocialWall.css';

const LikeButton = ({ postId, isLiked, likesCount, onToggle }) => {
  const handleClick = () => {
    onToggle(postId);
  };

  return (
    <button
      className={`like-button ${isLiked ? 'liked' : ''}`}
      onClick={handleClick}
      aria-label={isLiked ? 'Unlike' : 'Like'}
    >
      <Heart size={18} fill={isLiked ? 'currentColor' : 'none'} />
      <span className="like-count">{likesCount || 0}</span>
    </button>
  );
};

export default LikeButton;

